import { object, string, ValidationError } from 'yup'

import { TipoArticuloInputProps } from '../../../interfaces/tipoArticulo.ts'

/**
 * Validamos los datos de formulario de la unidad de medida
 * @param input
 */
export const tipoArticuloValidator = async (input: TipoArticuloInputProps): Promise<Array<string>> => {
  try {
    await TipoArticuloValidationSchema.validate(input, { abortEarly: false })
    return []
  } catch (error) {
    if (error instanceof ValidationError) {
      return error.inner.map((err) => err.message)
    }
    return [(error as Error).message]
  }
}

export const TipoArticuloValidationSchema = object({
  codigo: string().required('Ingrese el Código Tipo Artículo'),
  descripcion: string().required('Ingrese la Descripción'),
})
